/**
 * /docs entry — the layer documentation page. The component lives in
 * ./docs/DocsPage.ts (testable); this file only mounts it.
 */
import './docs/docs.css';
import { DeviceDetector } from './utils/DeviceDetector.js';
import { installPreloadErrorReload } from './utils/preloadErrorReload.js';
import { DocsPage } from './docs/DocsPage.js';
import { wikiApi } from './docs/WikiApiClient.js';

installPreloadErrorReload();
DeviceDetector.initialize();

const root = document.getElementById('docs-root');
if (root) new DocsPage(root, { api: wikiApi }).initialize();
